import {
    Box,
    Toolbar,
} from "@mui/material";
import {
    Dispatch,
    SetStateAction,
    memo,
    useMemo
} from "react";

import { DefaultDrawerListItems } from "./DefaultDrawerListItems";
import { OrganizationType } from "../../../API";
import { PropertyManagerDrawerListItems } from "./PropertyManagerDrawerListItems";
import { UserProfileSection } from "./UserProfileSection";
import { useUser } from "../../user/UserContext";

type SidebarDrawerContentsProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const SidebarDrawerContents = memo((props: SidebarDrawerContentsProps) => {
    const { isOpen, setIsOpen } = props;
    const { accountType } = useUser();

    const drawerListItems = useMemo(() => {
        switch (accountType) {
            case OrganizationType.PROPERTY_MANAGEMENT:
                return <PropertyManagerDrawerListItems isOpen={isOpen} setIsOpen={setIsOpen} />;
            case OrganizationType.CONSULTANT:
            case OrganizationType.SOLE_SOURCE:
            default:
                return <DefaultDrawerListItems isOpen={isOpen} setIsOpen={setIsOpen} />;
        }
    }, [accountType, isOpen, setIsOpen]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%"
            }}
        >
            <Toolbar />
            <UserProfileSection isOpen={isOpen} setIsOpen={setIsOpen} />
            {drawerListItems}
        </Box>
    );
});